export default __webpack_public_path__ + "static/media/a011-PPII-5.f77649b7.svg";